export default "__VITE_ASSET__CBDJK$Tt__"